export const PublicShell = ({ children }) => (
  <div className="relative min-h-screen bg-[#070709] text-white overflow-hidden sv-noise">
    <div className="sv-glow-orb w-[520px] h-[520px] bg-pink-600/20 -top-40 -left-40" />
    <div className="sv-glow-orb w-[600px] h-[600px] bg-violet-600/20 -bottom-60 -right-40" />
    <div className="relative z-10">{children}</div>
  </div>
);

export const PublicError = ({ text }) => (
  <PublicShell>
    <div className="min-h-screen grid place-items-center px-6 text-center" data-testid="public-error">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-pink-400 mb-4">404</p>
        <h1 className="font-display text-3xl font-bold">{text}</h1>
      </div>
    </div>
  </PublicShell>
);
